import { LOGO_GENISLIK, LOGO_KIRMIZI, LOGO_NERO, LOGO_PERFORMANCE, LOGO_YUKSEKLIK } from '@nero/shared';

/**
 * NERO PERFORMANCE LOGOSU
 *
 * Satır içi SVG olarak çizilir (harici dosya değil): "NERO" yazısı
 * `currentColor` kullandığı için bulunduğu yerin yazı rengini alır —
 * açık temada koyu, koyu temada açık görünür. Harici bir <img> bunu
 * yapamaz, çünkü dış SVG sayfanın renklerini miras almaz.
 *
 * @param yukseklik Piksel cinsinden yükseklik; genişlik orantıyla hesaplanır.
 */
export function NeroLogo({
  yukseklik = 22,
  className,
  baslik = 'Nero Performance',
}: {
  yukseklik?: number;
  className?: string;
  /** Ekran okuyucu için ad; süs amaçlıysa boş bırakın. */
  baslik?: string;
}) {
  const genislik = Math.round((yukseklik * LOGO_GENISLIK) / LOGO_YUKSEKLIK);
  return (
    <svg
      className={className}
      width={genislik}
      height={yukseklik}
      viewBox={`0 0 ${LOGO_GENISLIK} ${LOGO_YUKSEKLIK}`}
      role={baslik ? 'img' : 'presentation'}
      aria-label={baslik || undefined}
      aria-hidden={baslik ? undefined : true}
      focusable="false"
      style={{ display: 'block', flexShrink: 0 }}
    >
      {baslik && <title>{baslik}</title>}
      <g fill="currentColor">
        {LOGO_NERO.map((d, i) => <path key={`n${i}`} d={d} />)}
      </g>
      <g fill={LOGO_KIRMIZI}>
        {LOGO_PERFORMANCE.map((d, i) => <path key={`p${i}`} d={d} />)}
      </g>
    </svg>
  );
}
